import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label"];
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import useButtonClickTracker from 'personalization-lib/hooks/tracking/library/useButtonClickTracker';
import useBackToPersonalizationUrl from 'personalization-lib/hooks/nav/useBackToPersonalizationUrl';
import { getPersonalizationAccess } from 'personalization-lib/utils/auth';
import BaseErrorBoundary from '../shared/errorHandling/boundaries/BaseErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentEditorExitWrapper = ({
  children,
  strategyId,
  actionSource,
  buttonProps
}) => {
  const personalizationAccess = getPersonalizationAccess();
  const trackButtonClick = useButtonClickTracker({
    actionSource
  });
  const backToPersonalizationUrl = useBackToPersonalizationUrl(strategyId);
  if (personalizationAccess.view && backToPersonalizationUrl) {
    const _ref = buttonProps !== null && buttonProps !== void 0 ? buttonProps : {},
      {
        label
      } = _ref,
      buttonStyleProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(Button, Object.assign({
      href: backToPersonalizationUrl,
      onClick: trackButtonClick.backToPersonalization,
      "data-test-id": "personalization-back-button",
      use: "secondary-ghost"
    }, buttonStyleProps, {
      children: label !== null && label !== void 0 ? label : I18n.text('personalizationLib.navigation.backToPersonalization.label')
    }));
  }
  return children;
};
const ContentEditorExitWrapperErrorBoundary = props => /*#__PURE__*/_jsx(BaseErrorBoundary, {
  fallback: props.children,
  children: /*#__PURE__*/_jsx(ContentEditorExitWrapper, Object.assign({}, props))
});
export default ContentEditorExitWrapperErrorBoundary;